(function(){
  'use strict';

  function dispatch(name, detail){
    try { document.dispatchEvent(new CustomEvent(name, {detail: detail || {}})); } catch(e) {}
  }

  function readPreparedTotals(host){
    var node = host && host.querySelector('[data-aw-new-replica-prep-totals]');
    if(!node) return [];
    try { return JSON.parse(node.textContent || '[]'); }
    catch(e) { return []; }
  }

  function selectedVariantId(form){
    var idField = form && form.querySelector('[name="id"]');
    return idField && idField.value ? String(idField.value) : '';
  }

  function selectedPreparedRow(host, form){
    var rows = readPreparedTotals(host);
    var variantId = selectedVariantId(form);
    return rows.find(function(item){ return String(item.id) === variantId; }) || null;
  }

  function syncChoiceState(host, option){
    if(!host || !option) return;
    host.classList.toggle('is-selected', !!option.checked && !option.disabled);
    var label = host.querySelector('[data-aw-new-replica-prep-total-label]');
    if(label) label.textContent = option.checked && !option.disabled ? 'Total préparé' : 'Total si option choisie';
  }

  function syncPreparedState(host, form, option){
    if(!host || !form || !option) return;
    var row = selectedPreparedRow(host, form);
    var available = !!(row && row.available);
    var total = host.querySelector('[data-aw-new-replica-prep-total]');
    var totalWrap = host.querySelector('[data-aw-new-replica-prep-total-wrap]');
    var unavailable = host.querySelector('[data-aw-new-replica-prep-unavailable]');

    if(total && row && row.prepared_total) total.textContent = row.prepared_total;
    option.disabled = !available;
    if(!available) option.checked = false;
    if(totalWrap) totalWrap.hidden = !available;
    if(unavailable) unavailable.hidden = available;
    host.classList.toggle('is-variant-unavailable', !available);
    syncChoiceState(host, option);
  }

  function initAWReplicaPreparation(scope){
    (scope || document).querySelectorAll('[data-aw-new-replica-prep-host]').forEach(function(host){
      if(host.dataset.awPrepInit === 'true') return;
      var form = host.closest('form.aw-pdp-buy-form');
      if(!form) return;
      host.dataset.awPrepInit = 'true';

      var option = host.querySelector('[data-aw-new-replica-prep-toggle]');
      if(!option) return;
      var variantSelect = form.querySelector('[data-variant-select]');
      syncPreparedState(host, form, option);

      if(variantSelect && variantSelect.dataset.awPrepPriceBound !== 'true'){
        variantSelect.dataset.awPrepPriceBound = 'true';
        variantSelect.addEventListener('change', function(){
          requestAnimationFrame(function(){ syncPreparedState(host, form, option); });
        });
      }

      if(option.dataset.awPrepChoiceBound !== 'true'){
        option.dataset.awPrepChoiceBound = 'true';
        option.addEventListener('change', function(){
          syncChoiceState(host, option);
          dispatch('aw:atelier-preparation-option-changed', {
            selected: !!option.checked,
            exact_relation: host.dataset.exactRelation === 'true',
            replica_title: host.dataset.replicaTitle || '',
            service_variant_id: String(host.dataset.serviceVariantId || '')
          });
        });
      }

      if(form.dataset.awPrepBound === 'true') return;
      form.dataset.awPrepBound = 'true';

      form.addEventListener('submit', async function(event){
        var option = form.querySelector('[data-aw-new-replica-prep-toggle]');
        if(!option || !option.checked || option.disabled) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        var status = form.querySelector('[data-aw-new-replica-prep-status]');
        var idField = form.querySelector('[name="id"]');
        var quantityField = form.querySelector('[name="quantity"]');
        var mainVariantId = Number(idField && idField.value);
        var serviceVariantId = Number(host.dataset.serviceVariantId);
        var quantity = Math.max(1, parseInt(quantityField && quantityField.value ? quantityField.value : '1', 10) || 1);
        var addButton = form.querySelector('[data-add-button]');
        var stickyButton = form.id ? document.querySelector('[data-sticky-button][form="' + form.id + '"]') : null;
        var buttons = [addButton, stickyButton].filter(Boolean);
        var previousDisabled = buttons.map(function(button){ return button.disabled; });

        if(!mainVariantId || !serviceVariantId){
          if(status) status.textContent = 'Impossible de préparer cet ajout. Rechargez la page puis réessayez.';
          return;
        }

        var row = selectedPreparedRow(host, form);
        if(!row || !row.available){
          option.checked = false;
          syncPreparedState(host, form, option);
          if(status) status.textContent = 'Cette variante est indisponible. Sélectionnez une variante disponible.';
          return;
        }

        var analyticsDetail = {
          main_variant_id: String(mainVariantId),
          service_variant_id: String(serviceVariantId),
          quantity: quantity,
          replica_title: host.dataset.replicaTitle || '',
          exact_relation: host.dataset.exactRelation === 'true'
        };

        dispatch('aw:atelier-preparation-intent', analyticsDetail);
        buttons.forEach(function(button){button.disabled=true;button.setAttribute('aria-busy','true');});
        if(status) status.textContent = 'Ajout de la réplique et de la préparation…';

        try{
          var mainItem = {id:mainVariantId,quantity:quantity};
          var sellingPlan = form.querySelector('[name="selling_plan"]');
          if(sellingPlan && sellingPlan.value) mainItem.selling_plan = sellingPlan.value;
          var response = await fetch((host.dataset.addUrl || '/cart/add') + '.js', {
            method:'POST',
            headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:[mainItem,{id:serviceVariantId,quantity:quantity,properties:{'Réplique concernée':host.dataset.replicaTitle || ''}}]})
          });
          if(!response.ok){
            var errorPayload = await response.json().catch(function(){return {};});
            throw new Error(errorPayload.description || 'L’ajout au panier a échoué.');
          }
          dispatch('aw:atelier-preparation-added', analyticsDetail);
          dispatch('cart:updated', {
            source:'atelier_preparation',
            variant_id:String(mainVariantId),
            service_variant_id:String(serviceVariantId),
            quantity:quantity
          });
          window.location.assign(host.dataset.cartUrl || '/cart');
        }catch(error){
          buttons.forEach(function(button,index){button.disabled=previousDisabled[index];button.removeAttribute('aria-busy');});
          if(status) status.textContent = error && error.message ? error.message : 'L’ajout au panier a échoué.';
        }
      }, true);
    });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',function(){initAWReplicaPreparation(document);},{once:true});
  else initAWReplicaPreparation(document);
  document.addEventListener('shopify:section:load',function(event){initAWReplicaPreparation(event.target);});
})();
